module.exports = "<div id=\"miniframe\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/sketch/miniframes/miniframe.component.html
// module id = 55
// module chunks = 0